/**
 * Count the total number of graphemes (e.g. visible characters like emojis) within a piece of text. Spaces
 * and line breaks count as a character.
 */
export function countGraphemes(text: string): number {
  if (typeof Intl.Segmenter !== 'function') {
    throw new Error('Grapheme limits require Intl.Segmenter; install a Segmenter polyfill before rendering.');
  }
  const segmenter = new Intl.Segmenter(undefined, {granularity: 'grapheme'});
  return Array.from(segmenter.segment(text)).length;
}

/**
 * Returns true if the proposed candidate string is under the maxGraphemes number or if it is less than the
 * current string. This allows us to preserve over-limit values as long as they are making progress towards
 * the limit.
 *
 * Will throw an error if the `maxGraphemes` is a negative number.
 */
export function acceptsGraphemeEdit(current: string, candidate: string, maxGraphemes: number): boolean {
  if (!Number.isInteger(maxGraphemes) || maxGraphemes < 0) {
    throw new Error('maxGraphemes must be a non-negative integer');
  }
  const count = countGraphemes(candidate);
  return candidate === current || count <= maxGraphemes || count <= countGraphemes(current);
}
